var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"footer":null,"title":null,"width":"500px","maskClosable":false,"keyboard":false,"centered":"","closable":false,"getContainer":_vm.getContainer},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('a-result',{attrs:{"status":_vm.res.code == 1 ? 'error' : 'success'},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('a-icon',{attrs:{"type":_vm.confirmLoading
            ? 'loading'
            : _vm.res.code == 0
            ? 'check-circle'
            : 'close-circle'}})]},proxy:true},{key:"title",fn:function(){return [(_vm.confirmLoading)?_c('div',[_vm._v("录入中，请稍后")]):_c('div',[_vm._v(_vm._s(_vm.res.code == 0 ? "自动录入成功！" : "录入失败"))])]},proxy:true},{key:"subTitle",fn:function(){return [(!_vm.confirmLoading)?_c('div',[_vm._v("\n        "+_vm._s(_vm.res.code == 0
            ? `姓名：${_vm.res.data.name} 身份证号：${_vm.res.data.id_no.substring(
                0,
                6
              )}...${_vm.res.data.id_no.substring(
                _vm.res.data.id_no.length - 7,
                _vm.res.data.id_no.length - 1
              )} 录入成功！`
            : _vm.res.message
            ? _vm.res.message
            : "请重试")+"\n      ")]):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }